import classNames from 'classnames'

import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  className?: string
  content: string
}

const Toast = ({ className, content }: Props): ReactElement => {
  const toastClasses = classNames('toast-component', className)

  return (
    <div className={toastClasses}>
      <span>{content}</span>
    </div>
  )
}

export default Toast
